import { Moment } from 'moment';

export class Call {
  constructor(private readonly id: number, private readonly timestamp: Moment | null, private readonly keptByFilters: boolean) {}

  getId() {
    return this.id;
  }

  getTimestamp() {
    return this.timestamp;
  }

  isKeptByFilters() {
    return this.keptByFilters;
  }
}
